module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-search-follow"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "sf-modal-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('span', {
    staticClass: "sf-modal-btn-close material-icons",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "autocomplete": "off",
      "method": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "topsearch form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control follow-search-term",
    attrs: {
      "type": "text",
      "placeholder": "Tìm theo tên hiển thị"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": _vm.onFollowChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "addons-button-clear",
    style: (_vm.clear_search ? 'display:block;' : 'display:none;'),
    on: {
      "click": _vm.onFollowClear
    }
  }), _c('button', {
    staticClass: "follow-search-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitSearch($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 box-list-follow"
  }, _vm._l((_vm.user_followed), function(f) {
    return _c('div', {
      staticClass: "box-item-follow"
    }, [(f.userFollow.avatar) ? _c('img', {
      attrs: {
        "src": f.userFollow.avatar
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/images/faces/avt-default.png")
      }
    }), _c('p', [_vm._v(_vm._s(f.userFollow.fullname || 'default'))]), _c('itemAdding')], 1)
  }), 0)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 box-list-follow-mobile"
  }, _vm._l((_vm.user_followed), function(f) {
    return _c('div', {
      staticClass: "box-item-follow-mobile"
    }, [(f.userFollow.avatar) ? _c('img', {
      attrs: {
        "src": f.userFollow.avatar
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/images/faces/avt-default.png")
      }
    }), _c('p', [_vm._v(_vm._s(f.userFollow.fullname))]), _c('itemAdding')], 1)
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7756bce4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/modalFollowed.vue
// module id = 1612
// module chunks = 0